// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footerSoMe":"_1hyPjd","logoContainer":"_2uX0Lw","soMeContainer":"_1QCcxS","heading":"_20Uk1T","soMeBlock":"_1Y4ry0","soMeItem":"IJXlDB"};